// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","downloadIcon":"_1H-WP","downloadIcon_arrow":"_2EaLw","downloadIcon_line":"pUVF0","downloadIconAnimation":"_3m8Qp"};